import { render, staticRenderFns } from "./TheFavoriteContactItem.vue?vue&type=template&id=512c2ca8&scoped=true"
import script from "./TheFavoriteContactItem.vue?vue&type=script&lang=js"
export * from "./TheFavoriteContactItem.vue?vue&type=script&lang=js"
import style0 from "./TheFavoriteContactItem.vue?vue&type=style&index=0&id=512c2ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512c2ca8",
  null
  
)

export default component.exports